export type TitleMap = {
  [key: string]: string | { title: string; subRoutes?: { [subKey: string]: string } };
};

export function getRouteTitle(pathname: string, titleMap: TitleMap): string | undefined {
  const segments = pathname.split("/").filter(Boolean);

  if (segments.includes("reports")) {
    const reportsIndex = segments.indexOf("reports");
    const subRoute = segments[reportsIndex + 1];

    if (subRoute && typeof titleMap.reports === "object" && titleMap.reports.subRoutes?.[subRoute]) {
      return titleMap.reports.subRoutes[subRoute];
    }

    return typeof titleMap.reports === "object" ? titleMap.reports.title : (titleMap.reports as string);
  }

  for (let i = segments.length - 1; i >= 0; i--) {
    const key = segments[i];

    if (titleMap[key]) {
      return typeof titleMap[key] === "object" ? titleMap[key].title : (titleMap[key] as string);
    }
  }

  return undefined;
}
